// extracted by mini-css-extract-plugin
module.exports = {"light":"light-bulb_light__T83b0","bulb":"light-bulb_bulb__rVmJW"};